import { Icon, IContextualMenuItem, Spinner, SpinnerSize } from "@fluentui/react";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { BackgroundTaskStatusEnum } from "../../../src/taskpane/components/enums/BackgroundTaskStatusEnum";
import { RootState } from "../../../src/taskpane/redux";
import { setContentManagerExchangeProgress } from "../../../src/taskpane/redux/modules/contentManagerDirectory";
import { setIsBusySaving } from "../../../src/taskpane/redux/modules/savingInBackground";
import { LanguageContext } from "../../../utilities/LocalizationModule";
import { logger } from "../../../utilities/logger";
import { apiGetBackgroundTaskProgess } from "../../../src/taskpane/services/ApiService";

export function useMenuItem_SavingFiles(
  setIsCMMoveFilesListPanelOpen: (isCMMoveFilesListPanelOpen: boolean) => void,
  setIsFileUploadProgressPanelOpen: (isFileUploadProgressPanelOpen: boolean) => void
) {
  const languageStrings = React.useContext(LanguageContext);

  const dispatch = useDispatch();

  const isBusySaving = useSelector((state: RootState) => state.savingInBackground.isBusySaving);
  const exchangeProgress = useSelector((state: RootState) => state.contentManagerDirectory.exchange.progress);

  const [menuItem_SavingFiles, setMenuItem_SavingFiles] = React.useState<IContextualMenuItem>();
  const [hasError, setHasError] = React.useState(false);

  const [fetchProgress, setFetchProgress] = React.useState(0);

  React.useEffect(() => {
    if (isBusySaving === true && (!exchangeProgress || (exchangeProgress && !exchangeProgress.status))) {
      setMenuItem_SavingFiles(
        {
          key: "savingFiles",
          text: languageStrings.SavingFiles,
          disabled: false,
          onRenderIcon: () => {
            return <Spinner size={SpinnerSize.small} style={{ paddingRight: 5 }} />
          },
          onClick: () => setIsFileUploadProgressPanelOpen(true)
        }
      )
    } else if (isBusySaving === true && exchangeProgress && exchangeProgress.status) {
      setMenuItem_SavingFiles(
        {
          key: "savingFilesCount",
          text: exchangeProgress.message ? exchangeProgress.message : languageStrings.SavingFiles,
          disabled: false,
          onRenderIcon: () => {
            return <>
              {(exchangeProgress.status === BackgroundTaskStatusEnum.Inprogress || exchangeProgress.status === BackgroundTaskStatusEnum.Queued) && <Spinner size={SpinnerSize.small} style={{ paddingRight: 5 }} />}
              {exchangeProgress.status === BackgroundTaskStatusEnum.Completed && <Icon iconName="CheckMark" style={{ paddingRight: 5 }} />}
              {exchangeProgress.status === BackgroundTaskStatusEnum.Failure && <Icon iconName="Error" style={{ paddingRight: 5 }} />}
            </>
          },
          onClick: () => {
            setIsCMMoveFilesListPanelOpen(true);
          }
        }
      )
    } else {
      setMenuItem_SavingFiles(null)
    }
  }, [isBusySaving, exchangeProgress]);

  React.useEffect(() => {
    if (!hasError && fetchProgress === 0 && exchangeProgress && exchangeProgress.status && exchangeProgress.status !== BackgroundTaskStatusEnum.Completed && exchangeProgress.status !== BackgroundTaskStatusEnum.Failure) {
      setFetchProgress(prev => prev + 1);
    }
  }, [fetchProgress, exchangeProgress]);

  React.useEffect(() => {
    let timer;
    if (fetchProgress > 0) {
      timer = setTimeout(() => {
        updateProgress();
      }, 3000);
    }

    return () => {
      clearTimeout(timer);
    };
  }, [fetchProgress]);

  const updateProgress = async () => {
    try {
      const progressRes = await apiGetBackgroundTaskProgess(exchangeProgress.taskId);
      dispatch(setContentManagerExchangeProgress(progressRes));

      if (progressRes.status === BackgroundTaskStatusEnum.Inprogress || progressRes.status === BackgroundTaskStatusEnum.Queued) {
        setFetchProgress(prev => prev + 1);
      } else {
        setFetchProgress(0);
        dispatch(setIsBusySaving({ isBusySaving: false, isSuccess: true }));
      }
    } catch (error) {
      let message = error.data?.title ? `${languageStrings.Error}: ${error.data?.title}` : languageStrings.ErrorMessageGeneric;
      logger(error, "useMenuItem_SavingFiles.tsx (updateProgress)");
      setFetchProgress(0);
      setHasError(true);
      dispatch(setIsBusySaving({ isBusySaving: false, isSuccess: false, errorMessages: [message] }));
    }
  }

  return {
    menuItem_SavingFiles
  }

}